import FormattedMessage from 'I18n/components/FormattedMessage';
import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { View } from 'foundations-components/transitional/components/View';
import { NavMarker } from 'react-rhumb';
import { EcosystemListingCard } from 'trellis-ecosystem';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { CollectionCard } from '../components/CollectionCard';
import { HeaderView } from '../components/headers/HeaderView';
import { PageHeader } from '../components/headers/PageHeader';
import { Paths } from '../constants/paths';
import { StorefrontFilterBar } from '../filters/components/StorefrontFilterBar';
import { StorefrontPaginator } from '../navigation/components/StorefrontPaginator';
import { usePagination } from '../navigation/hooks/usePagination';
import { createMockCollection, createMockListing } from '../queries/mockHomepageData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CollectionCta() {
  const collections = Array.from({
    length: 2
  }, createMockCollection);
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "featured-collection-cta",
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      paddingBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.featuredCollection.ctaTitle"
        })
      }), /*#__PURE__*/_jsx(UIRouterLink, {
        to: Paths.FEATURED,
        onClick: () => window.scrollTo(0, 0),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.featuredCollection.ctaLink"
        })
      })]
    }), /*#__PURE__*/_jsx(CardGrid, {
      columns: 2,
      gap: "400",
      children: collections.map(collection => /*#__PURE__*/_jsx(CollectionCard, Object.assign({
        "data-test-id": "ecosystem-collection-card"
      }, collection), collection.name))
    })]
  });
}
export function FeaturedCollection({
  collectionName = 'Mock Featured Collection Name',
  collectionSubtext = 'Mock Featured Collection Subtext'
}) {
  // Generate 21 mock listings
  const listings = Array.from({
    length: 21
  }, createMockListing);
  const {
    currentPage,
    paginatedItems: paginatedListings,
    pageCount,
    needsPagination,
    handlePageChange
  } = usePagination({
    items: listings
  });
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "FEATURED_COLLECTION_LOAD",
    children: /*#__PURE__*/_jsxs(DashboardPage, {
      headerComponent: /*#__PURE__*/_jsx(HeaderView, {}),
      children: [/*#__PURE__*/_jsx(PageHeader, {
        title: collectionName,
        description: collectionSubtext,
        compact: true
      }), /*#__PURE__*/_jsx(StorefrontFilterBar, {}), /*#__PURE__*/_jsx(CardGrid, {
        "data-test-id": "featured-collection-grid",
        columns: 4,
        gap: "400",
        children: paginatedListings.map(listing => /*#__PURE__*/_jsx(View, {
          "data-test-id": "ecosystem-listing-card",
          children: /*#__PURE__*/_jsx(EcosystemListingCard, Object.assign({}, listing))
        }, listing.name))
      }), needsPagination && /*#__PURE__*/_jsx(StorefrontPaginator, {
        currentPage: currentPage,
        pageCount: pageCount,
        onPageChange: handlePageChange
      }), /*#__PURE__*/_jsx(CollectionCta, {})]
    })
  });
}